//
// When we scroll down the page more than 60px
// add a class "compressed" to the header
// so it 'retracts'
//
export default function compress_header () {
    var scrollPosition = window.pageYOffset;
    const headerObj = document.getElementById( 'header' );

    window.addEventListener( 'scroll', function() {
        scrollPosition = window.pageYOffset;
        if (scrollPosition >= 60) {
            headerObj.classList.add('compressed');
        } else {
            headerObj.classList.remove('compressed');
        }
    });
}